import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";

const LoginError = ({ location }) => {
  const { error, error_description } = location.query;
  return (
    <div className="bg-dots page-header-dots">
      <div className="container">
        <React.Fragment>
          <h4>Oops! It seems that there has been an error in the authentication flow</h4>
          {error && (
            <pre>
              {error} {error_description}
            </pre>
          )}
          Try <a href="/login">logging in again</a> or <Link to="/">return to the home page</Link>.
        </React.Fragment>
      </div>
    </div>
  );
};

LoginError.propTypes = {
  location: PropTypes.object
};

export default LoginError;
